const listVersion = (state) => state.listVersion;

export default {
  listVersion,
};
